
export const DATE_FORMAT = 'YYYY-MM-DD'
export const ALL_AIRPORTS_CODE = 'ALL'
export const TEMPERATURE_MAX = 99
export const TEMPERATURE_MIN = 0
